export const SESSION_CONFIG = {
    TIMEOUT_DURATION: 30 * 60 * 1000, // 30 minutes in milliseconds
    WARNING_DURATION: 5 * 60 * 1000, // 5 minutes warning before timeout
    // TIMEOUT_DURATION: 3 * 60 * 1000,   // 3 minute in milliseconds
    // WARNING_DURATION: 1 * 60 * 1000, // 1 minute warning before timeout
    ACTIVITY_EVENTS: ['mousedown', 'keydown', 'touchstart', 'scroll', 'click', 'mousemove']
};
